module.exports = __webpack_public_path__ + "img/logo1 (41).3425c73d.jpg";